module.exports = __webpack_public_path__ + "static/image1-a9c6e52a57d967d73e359d79c5cdec9f.jpg";